var _circle, _circle2, _g, _circle3, _g2, _g3, _g4, _rect, _ellipse, _ellipse2, _ellipse3, _g5, _g6, _g7, _g8, _g9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroAble(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "78 56 380 282",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, "Three people at work, one using a wheelchair, with a job offer card") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 200,
    r: 160,
    fill: "#dbeafe"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 380,
    cy: 96,
    r: 34,
    fill: "#ffffff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#2563eb",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376 88 l2 16 h14 l6 13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372 96 a14 14 0 1 0 18 18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377 96 h12"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 375,
    cy: 78,
    r: 5,
    fill: "#2563eb"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#bfdbfe"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 168,
    width: 40,
    height: 150,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 128,
    width: 36,
    height: 190,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 146,
    width: 40,
    height: 172,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346,
    y: 188,
    width: 48,
    height: 130,
    rx: 4
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#93c5fd"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 102,
    width: 12,
    height: 40,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 138,
    width: 32,
    height: 180,
    rx: 4
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250,66 254,102 246,102"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 182,
    width: 9,
    height: 11,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 182,
    width: 9,
    height: 11,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 142,
    width: 8,
    height: 10,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171,
    y: 142,
    width: 8,
    height: 10,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 152,
    width: 7,
    height: 9,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 152,
    width: 7,
    height: 9,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308,
    y: 160,
    width: 9,
    height: 11,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323,
    y: 160,
    width: 9,
    height: 11,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 202,
    width: 11,
    height: 11,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373,
    y: 202,
    width: 11,
    height: 11,
    rx: 2
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 318,
    width: 360,
    height: 8,
    rx: 4,
    fill: "#60a5fa"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 140,
    cy: 320,
    rx: 32,
    ry: 4,
    fill: "#1d4ed8",
    opacity: 0.18
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 236,
    cy: 320,
    rx: 32,
    ry: 4,
    fill: "#1d4ed8",
    opacity: 0.18
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 320,
    cy: 320,
    rx: 32,
    ry: 4,
    fill: "#1d4ed8",
    opacity: 0.18
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 246,
    width: 13,
    height: 68,
    rx: 6,
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151,
    y: 246,
    width: 13,
    height: 68,
    rx: 6,
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133 318 q0 -9 9 -9 h3 v9 z",
    fill: "#111827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167 318 q0 -9 -9 -9 h-3 v9 z",
    fill: "#111827"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 184,
    width: 42,
    height: 68,
    rx: 15,
    fill: "#f97316"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 168,
    width: 12,
    height: 20,
    rx: 5,
    fill: "#ae753a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141 186 q9 7 18 0",
    fill: "none",
    stroke: "#c75c11",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133 194 Q121.5 219.0 124 244",
    fill: "none",
    stroke: "#f97316",
    strokeWidth: 11,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 244,
    r: 5.5,
    fill: "#c68642"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167 194 Q180.5 204.0 180 214",
    fill: "none",
    stroke: "#f97316",
    strokeWidth: 11,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 214,
    r: 5.5,
    fill: "#c68642"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 152,
    r: 18,
    fill: "#c68642"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 153,
    r: 3.5,
    fill: "#c68642"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 153,
    r: 3.5,
    fill: "#c68642"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 137,
    cy: 140,
    r: 8,
    fill: "#111827"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146,
    cy: 134,
    r: 9,
    fill: "#111827"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157,
    cy: 134,
    r: 9,
    fill: "#111827"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 165,
    cy: 141,
    r: 8,
    fill: "#111827"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133,
    cy: 149,
    r: 6,
    fill: "#111827"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 149,
    r: 6,
    fill: "#111827"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 153,
    r: 2.2,
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156,
    cy: 153,
    r: 2.2,
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145 161 q5 4.5 10 0",
    fill: "none",
    stroke: "#1f2937",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 139,
    cy: 159,
    r: 2.6,
    fill: "#f87171",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 159,
    r: 2.6,
    fill: "#f87171",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(8 184 215)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 200,
    width: 24,
    height: 30,
    rx: 3,
    fill: "#ffffff",
    stroke: "#2563eb",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177,
    y: 207,
    width: 14,
    height: 3,
    rx: 1.5,
    fill: "#2563eb",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177,
    y: 214,
    width: 10,
    height: 3,
    rx: 1.5,
    fill: "#d1d5db"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 214,
    y: 214,
    width: 52,
    height: 58,
    rx: 8,
    fill: "#334155"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 252,
    width: 10,
    height: 66,
    rx: 5,
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 252,
    width: 10,
    height: 66,
    rx: 5,
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 260,
    width: 4,
    height: 50,
    rx: 2,
    fill: "#94a3b8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284,
    y: 260,
    width: 4,
    height: 50,
    rx: 2,
    fill: "#94a3b8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 268,
    width: 56,
    height: 9,
    rx: 4,
    fill: "#475569"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 270,
    width: 14,
    height: 22,
    rx: 6,
    fill: "#334155"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241,
    y: 270,
    width: 14,
    height: 22,
    rx: 6,
    fill: "#334155"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227,
    y: 286,
    width: 11,
    height: 20,
    rx: 5,
    fill: "#334155"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 286,
    width: 11,
    height: 20,
    rx: 5,
    fill: "#334155"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 308,
    width: 48,
    height: 5,
    rx: 2.5,
    fill: "#475569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223 308 q0 -8 8 -8 h3 v8 z",
    fill: "#111827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257 308 q0 -8 -8 -8 h-3 v8 z",
    fill: "#111827"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 314,
    r: 4,
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260,
    cy: 314,
    r: 4,
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 40)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 219,
    y: 184,
    width: 42,
    height: 68,
    rx: 15,
    fill: "#2563eb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 168,
    width: 12,
    height: 20,
    rx: 5,
    fill: "#d4b091"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231 186 q9 7 18 0",
    fill: "none",
    stroke: "#1d4fbc",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223 194 Q206.0 211.0 203 228",
    fill: "none",
    stroke: "#2563eb",
    strokeWidth: 11,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203,
    cy: 228,
    r: 5.5,
    fill: "#f1c9a5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257 194 Q274.0 211.0 277 228",
    fill: "none",
    stroke: "#2563eb",
    strokeWidth: 11,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277,
    cy: 228,
    r: 5.5,
    fill: "#f1c9a5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 152,
    r: 18,
    fill: "#f1c9a5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222,
    cy: 153,
    r: 3.5,
    fill: "#f1c9a5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258,
    cy: 153,
    r: 3.5,
    fill: "#f1c9a5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222 150 q-1 -21 18 -21 q19 0 18 21 q-6 -9 -18 -10 q-12 1 -18 10 z",
    fill: "#4b5563"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234,
    cy: 153,
    r: 2.2,
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246,
    cy: 153,
    r: 2.2,
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235 161 q5 4.5 10 0",
    fill: "none",
    stroke: "#1f2937",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229,
    cy: 159,
    r: 2.6,
    fill: "#f87171",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251,
    cy: 159,
    r: 2.6,
    fill: "#f87171",
    opacity: 0.35
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 315,
    y: 262,
    width: 9,
    height: 52,
    rx: 4.5,
    fill: "#5a3825"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328,
    y: 262,
    width: 9,
    height: 52,
    rx: 4.5,
    fill: "#5a3825"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309 318 q0 -9 9 -9 h3 v9 z",
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343 318 q0 -9 -9 -9 h-3 v9 z",
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310 236 h32 l8 32 h-48 z",
    fill: "#e5e7eb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305,
    y: 184,
    width: 42,
    height: 68,
    rx: 15,
    fill: "#10b981"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 168,
    width: 12,
    height: 20,
    rx: 5,
    fill: "#4f3120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317 186 q9 7 18 0",
    fill: "none",
    stroke: "#0c9467",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309 194 Q297.0 216.0 299 238",
    fill: "none",
    stroke: "#10b981",
    strokeWidth: 11,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299,
    cy: 238,
    r: 5.5,
    fill: "#5a3825"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343 194 Q356.5 210.0 356 226",
    fill: "none",
    stroke: "#10b981",
    strokeWidth: 11,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 356,
    cy: 226,
    r: 5.5,
    fill: "#5a3825"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 326,
    cy: 152,
    r: 18,
    fill: "#5a3825"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 308,
    cy: 153,
    r: 3.5,
    fill: "#5a3825"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 344,
    cy: 153,
    r: 3.5,
    fill: "#5a3825"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 326,
    cy: 128,
    r: 9,
    fill: "#111827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308 151 q-1 -21 18 -21 q19 0 18 21 q-5 -10 -18 -11 q-13 1 -18 11 z",
    fill: "#111827"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 153,
    r: 2.2,
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 332,
    cy: 153,
    r: 2.2,
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321 161 q5 4.5 10 0",
    fill: "none",
    stroke: "#1f2937",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315,
    cy: 159,
    r: 2.6,
    fill: "#f87171",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 337,
    cy: 159,
    r: 2.6,
    fill: "#f87171",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 212,
    width: 32,
    height: 20,
    rx: 3,
    fill: "#334155"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 215,
    width: 26,
    height: 14,
    rx: 1.5,
    fill: "#93c5fd"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 232,
    width: 40,
    height: 4,
    rx: 2,
    fill: "#475569"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(358 250) rotate(4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 54,
    rx: 11,
    fill: "#ffffff",
    stroke: "#bfdbfe",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 10,
    fill: "#2563eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 19 l3.5 3.5 l7 -7.5",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 12,
    width: 50,
    height: 6,
    rx: 3,
    fill: "#1f2937"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 23,
    width: 34,
    height: 5,
    rx: 2.5,
    fill: "#d1d5db"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 38,
    width: 73,
    height: 7,
    rx: 3.5,
    fill: "#dbeafe"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 38,
    width: 46,
    height: 7,
    rx: 3.5,
    fill: "#2563eb"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "#f59e0b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92 112 l4 9 l9 4 l-9 4 l-4 9 l-4 -9 l-9 -4 l9 -4 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420 172 l3 6 l6 3 l-6 3 l-3 6 l-3 -6 l-6 -3 l6 -3 z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroAble);
export default __webpack_public_path__ + "static/media/hero-able.12ffc8148f93f04145f80d278e7de0e1.svg";
export { ForwardRef as ReactComponent };